type T = (key: string, opts?: any) => string
const strip = (m: string) => m.replace(/^GraphQL error: /, '').trim()

export const describeScheduleError = (message: string | undefined | null, t: T): string => {
  const m = strip(message ?? '')
  if (m.startsWith('Schedule_cycle:')) return t('Schedule_error_cycle', { path: m.slice('Schedule_cycle:'.length).trim() })
  if (m.startsWith('Schedule_cycle')) return t('Schedule_error_cycle', { path: '' })
  if (m === 'Archived schedules are read-only.') return t('Schedule_error_archived')
  if (m === 'This dependency already exists.') return t('Schedule_error_duplicate_dependency')
  if (m === 'Not Authorised!') return t('Schedule_error_not_authorised')
  if (m.startsWith('Schedule_import_not_xml')) return t('Schedule_import_not_xml')
  if (m.startsWith('Schedule_import_mpp_not_supported')) return t('Schedule_import_mpp_not_supported')
  return m || t('Common_error')
}
